import $ from 'jquery';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import Headroom from 'headroom.js';
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
import noUiSlider from 'nouislider';
import 'magnific-popup';
import {loadState, saveState} from './helpers/localStorage';
import { gsap, TweenMax, TimelineLite } from "gsap";
import wNumb from 'wnumb';

const Mangrove = {
  init() {
    this.cache();
    this.events();
    this.rangeSliders();
    this.fillNotebook();
    this.checkAnswers();
    this.initPopup();
    this.initialScreen();
  },
  cache() {
    this.$doc = $(document);
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.$mainWrap = $('main');
    this.$header = $('.js-header');
    this.$mobileNav = $('.js-mobile-nav');
    this.$hamburger = $('.js-hamburger');
    this.$tab = $('.js-tab');
    this.$notebook = $('.js-notebook');
    this.state = loadState() ? loadState() : {};
    this.$lastQuestionCta = $(".last-question-cta");
  },
  events() {
    this.$doc.on('click', '.js-tab', event => this.toggleNotebook(event));
    this.$doc.on('click', '.notebook-open .scroll-container', event => this.toggleNotebook(event));
    this.$doc.on('click', '.copy-url', event => this.copyUrlToClipboard(event));
    this.$doc.on('click', '.last-question-cta', event => this.lastQuestion(event));
    this.$doc.on('click', '.select-btn', event => this.inputColorStates(event, "radio"));
    this.$doc.on('keyup', '.question__answers--open span', event => this.inputColorStates(event, "input"));
    this.$doc.on('click', '.question__check-cta', event => this.inputColorStates(event, "btnRadioSubmit"));
    this.$doc.on('click', '.submitAnswer', event => this.inputColorStates(event, "openInputSubmit"));
    this.$doc.on('click', '.question__submit-cta', event => this.inputColorStates(event, "question__submit-cta"));
    this.$doc.on('click', '.submitAnswer', event => this.updateInput(event, "input"));
    this.$doc.on('click', '.question__check-cta', event => this.updateInput(event, "radio"));
    this.$doc.on('click', '.js-fill-email', event => this.createEmailContent(event));
    this.$doc.on('click', '.gallery-fixed__header__next', event => this.mobileNavigation(event, "next"));
    this.$doc.on('click', '.gallery-fixed__header__prev', event => this.mobileNavigation(event, "prev"));
    this.$win.on('resize', event => this.checkDeviceType(event));
  },
  inputColorStates(event, type){
    const { answeredSaved } = this;
    const { currentTarget } = event;
    const $question = $(currentTarget).closest('.js-question');
    if(type === 'btnRadioSubmit'){
      this.answeredSaved();
      $($question).find("form label").addClass("inactive");
      $($question).find("form input").attr("disabled", true);
      $($question).find(".selected").removeClass("focused").addClass("active");
    }
    else if(type === 'question__submit-cta'){
      this.answeredSaved();
    }
    else if(type === 'openInputSubmit'){
      this.answeredSaved();
      $($question).find("input[type=text]").attr("disabled", true);
      $($question).find(".question__answers--open a").removeClass("active");
    }
    else if(type === 'radio'){
      $($question).find("label").removeClass("selected focused active");
      $(currentTarget).siblings().addClass("selected focused");
      $($question).find(".question__check-cta").addClass("active");
    }
    else if(type === 'input'){
      $($question).find(".question__answers--open a").addClass("active");
    }
  },
  answeredSaved(){
    gsap.to($(".answer-saved"), { duration: 1, bottom: "26px", ease: "expo.inOut" });
    gsap.to($(".answer-saved"), { duration: 1, delay: 2, bottom: "-60px", ease: "expo.inOut" });
    gsap.to($(".js-notebook-desktop .notebook__box"), { duration: 0, transition: "none"});
    gsap.to($(".js-notebook-desktop .notebook__box"), { duration: .3, delay: 0, width: "80px", ease: "linear"});
    gsap.to($(".js-notebook-desktop .notebook__box"), { duration: 1, delay: .3, width: "65px", ease: "Bounce.easeOut"});
    gsap.to($(".js-notebook-desktop .notebook__box"), { delay: 2, transition: "all .3s ease-in-out" });

    gsap.to($(".js-notebook-mobile .notebook__box"), { duration: 0, transition: "none"});
    gsap.to($(".js-notebook-mobile .notebook__box"), { duration: .3, delay: 0, height: "55px", ease: "linear"});
    gsap.to($(".js-notebook-mobile .notebook__box"), { duration: 1, delay: .3, height: "45px", ease: "Bounce.easeOut"});
    gsap.to($(".js-notebook-mobile .notebook__box"), { delay: 2, transition: "all .3s ease-in-out" });
  },
  setState(id, res) {
    let { state, fillNotebook } = Mangrove;

    res = Array.isArray(res) ? res.join(', ') : res;
    state[id] = res;

    saveState(state);

    fillNotebook = fillNotebook.bind(this);
    fillNotebook();
  },
  updateInput(event, type) {
    const { currentTarget } = event;
    let correctValues, selectedValues, responseText, selectedPoints;
    const $question = $(currentTarget).closest('.js-question');
    const question = $question.find('.question__text').text()

    if(type === "radio"){
      const value = $(currentTarget).parent().find(".selected").text();
      let { setState } = this;
      correctValues = $question.find("input[data-correct=1]").attr('value');
      selectedPoints = "";
      responseText = "";
      selectedValues = value;
      setState = setState.bind(this)
      $($question).find(".question__check-cta").hide();
      setState($question ? $question.data('qid') : 0, {  questionType: "radio", questionText: question, responseText, selectedValues, correctValues, selectedPoints, submitted: "true" })
    }
    else if (type === "input"){
      const values = $($question).find("form span").text();
      let { setState } = this;
      correctValues = "";
      selectedPoints = "";
      responseText = "";
      setState = setState.bind(this)
      selectedValues = values;
      $($question).find(".submitAnswer").hide();
      setState($question ? $question.data('qid') : 0, {  questionType: "input", questionText: question, responseText, selectedValues, correctValues, selectedPoints, submitted: "true" })
    }
  },
  lastQuestion(){
    if($(".input-role").text().length != 0){
      let correctValues, selectedValues, responseText, selectedPoints;
      const $question = $(".notebook__sidebar__last__input");
      let { setState } = this;
      let inputText = $(".input-role").text()
      const question = $(".notebook__sidebar__last__inner").find('h2').text()
      correctValues = "";
      responseText = "",
      selectedPoints = "";
      selectedValues = inputText;
      setState = setState.bind(this)
      setState($question ? $question.data('qid') : 0, { questionType: "input", questionText: question, responseText, selectedValues, correctValues, selectedPoints, submitted: "true"})
    }
  },
  updateRange(values, handle, unencoded, tap, positions, noUiSlider) {
    const { target } = noUiSlider;
    let { appendDoubleAnswerRange, calcDistance } = Mangrove;
    let { setState, state } = Mangrove;
    let correctValues, selectedValues, responseText, selectedPoints;
    let selectedDistance;

    const $response = target.getAttribute("text-response");
    if ( $response ) responseText = $response;
    else responseText = "Please add text response in the backend.";

    setState = setState.bind(Mangrove)
    const $question = $(target).closest('.js-question');
    let $questionRangeUnit = $($question).find('.question__range').attr('range-unit');
    // we need to get selected points, then their text values
    // we also need to get correct points, then their text values as well (they are not the same bc text is not always nubmer and it's messing up with range init)
    let point1 = parseInt(values[0]),
        point2 = parseInt(values[1]);

    if(point2) selectedPoints = [point1, point2];
    else selectedPoints = [point1]

    let correctPoint1 = $(target).attr("data-correct1"),
        correctPoint2 = $(target).attr("data-correct2");

    if(point1 && point2) selectedValues = [point1 + $questionRangeUnit, point2 + $questionRangeUnit];
    else selectedValues = [point1 + $questionRangeUnit];

    if(correctPoint1 && correctPoint2) correctValues = [correctPoint1 + $questionRangeUnit, correctPoint2 + $questionRangeUnit];
    else correctValues = [correctPoint1 + $questionRangeUnit];

    const question = $question.find('.question__text').text()
    let submit = $($question).find(".question__submit-cta");

    if($($question).find(".question__submit-cta")){
      let submit = $($question).find(".question__submit-cta");
      $(submit).addClass("active");
    }

    if(point1 && point2){
      let firstSpot = $(target).find(".noUi-handle.noUi-handle-lower");
      let secondSpot = $(target).find(".noUi-handle.noUi-handle-upper");
      selectedDistance = calcDistance(firstSpot, secondSpot);

      let rangeArrowElement = $(target).find(".range-selected");
      let firstTabLeftValue = 0;
      $(rangeArrowElement).css('width', selectedDistance);

      if(parseInt(values[0]) < parseInt(values[1])) $(rangeArrowElement).css('left', 0);
      else if(parseInt(values[0]) >= parseInt(values[1])){
        firstTabLeftValue = -1*selectedDistance;
        $(rangeArrowElement).css('left', -1*selectedDistance);
      }
    }

    $(submit).on('click', function(){
      let distance, firstTabLeftValue;
      if($($question).find(".question__range").attr("slider-type") != 'singleslider'){
        const pointOne = $($question).find(".appended1");
        const pointTwo = $($question).find(".appended2");

        distance = calcDistance(pointOne, pointTwo);
        $($question).find(".connect-line").css("width", distance);
        // selectedDistance = 0;
        firstTabLeftValue = 0;
      }
      else {
        selectedDistance = 0;
        distance = 0;
      }

      console.log(distance);
      console.log(selectedDistance);

      setState($question.data('qid'), {  questionType: "range", questionText: question, responseText, selectedValues, correctValues, selectedPoints, submitted: "true", distance, selectedDistance, firstTabLeftValue })
      let $this = this;
      $(submit).removeClass("active");
      $($question).find(".question__answers--range").addClass("disabled");
      appendDoubleAnswerRange($this, distance);
    })
  },
  rangeSliders(){
    let { updateRange, inputColorStates, setNewRangeState, calcDistance } = this;
    var sliders = $('.question__range');
    var start, tooltips, dataPointsArr, dataPoints;

    $(sliders).each(function( index, elem ) {
      dataPoints = $(elem).attr('data-points');
      dataPointsArr = $.map(dataPoints.split(', '), function(value){
        return value;
      });

      let rangeUnit = $(elem).attr('range-unit');
      if($(elem).attr('slider-type') === 'multislider') {
        start = [0, 100];
        tooltips = [ wNumb({ decimals: 0, suffix: rangeUnit }), wNumb({ decimals: 0, suffix: rangeUnit }) ];
      }
      else {
        start = [0];
        tooltips = [ wNumb({ decimals: 0, suffix: rangeUnit }) ];
      }

      const rangeSlider = noUiSlider.create(elem, {
        start: start,
        tooltips: tooltips,
        range: {
         'min': [parseInt(dataPointsArr[0]), 1],
         '25%': [parseInt(dataPointsArr[1]), 1],
         '50%': [parseInt(dataPointsArr[2]), 1],
         '75%': [parseInt(dataPointsArr[3]), 1],
         'max': [parseInt(dataPointsArr[4]), 1]
        },
        step: 1,
        behaviour: 'unconstrained-tap',
        connect: true,
        pips: {
          mode: 'steps',
          values: parseInt(dataPointsArr[4]),
          density: 1,
          format: {
            decimals: 1,
            suffix: rangeUnit,
            to: function(a){
              return a + rangeUnit;
            }
          }
        }
      });
      rangeSlider.on('slide', updateRange);

      if($(elem).attr('slider-type') === 'multislider'){
        let rangeID = $(elem).attr("id").split("-");
        let correctValue1 = $(elem).attr('data-correct1'),
            correctValue2 = $(elem).attr('data-correct2'),
            correctEl1 = $(elem).find('.noUi-value-horizontal[data-value='+correctValue1+']'),
            correctEl2 = $(elem).find('.noUi-value-horizontal[data-value='+correctValue2+']');
        $(correctEl1).addClass('correct-element1');
        $(correctEl2).addClass('correct-element2');
        if($(correctEl1).find(".noUi-handle--appended").length === 0){
          $(correctEl1).append('<div class="appended1 noUi-handle noUi-handle--appended noUi-handle-lower" data-handle="2" tabindex="0" role="slider" aria-orientation="horizontal" aria-valuemin="0.0" aria-valuemax="100.0" aria-valuenow="'+correctValue1+'" aria-valuetext="'+correctValue1+'"><div class="noUi-touch-area"></div><div class="connect-line"></div><div class="noUi-tooltip">' + correctValue1 + rangeUnit + '</div></div>');
          $(correctEl2).append('<div class="appended2 noUi-handle noUi-handle--appended noUi-handle--appended-white noUi-handle-lower" data-handle="3" tabindex="0" role="slider" aria-orientation="horizontal" aria-valuemin="0.0" aria-valuemax="100.0" aria-valuenow="'+correctValue2+'" aria-valuetext="'+correctValue2+'"><div class="noUi-touch-area"></div><div class="noUi-tooltip">' + correctValue2 + rangeUnit + '</div></div>');
          $(`[data-nid=${rangeID[1]}]`).find(".notes__response__correct").show();
        }
      }
      else{
        let selectedValue = $(elem).find('.noUi-handle[aria-valuenow]').attr('aria-valuenow').split("."),
            correctValue = $(elem).attr('data-correct1'),
            selectedEl = $(elem).find('.noUi-handle[aria-valuenow]'),
            rangeID = $(elem).attr("id").split("-"),
            correctEl = $(elem).find('.noUi-value-horizontal[data-value='+correctValue+']');
        if($(correctEl).find(".noUi-handle--appended").length === 0){
          $(correctEl).addClass('correct-element');
          $(correctEl).append('<div class="noUi-handle noUi-handle--appended noUi-handle-lower" data-handle="2" tabindex="0" role="slider" aria-orientation="horizontal" aria-valuemin="0.0" aria-valuemax="100.0" aria-valuenow="'+correctValue+'" aria-valuetext="'+correctValue+'"><div class="noUi-touch-area"></div><div class="noUi-tooltip">' + correctValue + rangeUnit + '</div></div>');
        }
        $(`[data-nid=${rangeID[1]}]`).find(".notes__response__correct").show();
      }
    });
    // for black line on range update
    $(".noUi-base .noUi-handle.noUi-handle-lower").append("<div class='range-selected'></div>");
  },
  fillNotebook() {
    let { setState, state, appendDoubleAnswerRange, calcDistance } = this;
    if($(window).width() <= 768) {
      $(".notebook").addClass("js-notebook-mobile");
    }
    else{
      $(".notebook").addClass("js-notebook-desktop");
    }
    for (const [id, value] of Object.entries(this.state)) {
      const $notes = $(`.js-notes[data-nid="${id}"]`);
      const $question = $(`.js-question[data-qid="${id}"]`);
      const $questionType = $(`.js-question[data-qid="${id}"]`).find('[question-type]').attr('question-type');
      const $answers = $question.find('.question__answers');
      let $correct = '', $actual = '', $correctText = '', $actualText = '';

      if ( $answers.hasClass('question__answers--multiple') ) {
        $correct = $answers.find('input[data-correct="1"]');
        $actual  = $answers.find(`input[value="${value['selectedValues']}"]`);
        $correctText = $($correct).attr('value');
        $actualText = $($actual).attr('value');

        $correct.closest('.choice-box').addClass('choice-box--correct');
        $actual.prop("checked", true);
        $(".choice-box--correct").find(".check-icon").show();
        // add style classes to regular questions if question is filled out, and prevent changes on refresh once q is submited..
        $($question).find("form label").addClass("inactive");
        $($question).find("form input").attr("disabled", true);
        $($correct).siblings().addClass('correct');
        $($actual).siblings().addClass('active');
        $($question).find(".question__check-cta").hide();
      }
      if ( $answers.hasClass('question__answers--range') ) {
        if(value['submitted'] === 'true') {
          let existingSlider = '#slider-' + id,
              newSlider = '#slider' + id;
          value['selectedPoints'] && $(existingSlider)[0].noUiSlider.set(value['selectedPoints'])
          $($question).find(".question__answers--range").addClass("disabled");

          let cta = $($question).find('.question__submit-cta');
          let correctAnswersDistance = value['distance'];

          if($($question).find(".question__range").attr("slider-type") != 'singleslider') appendDoubleAnswerRange(cta, correctAnswersDistance);
          else appendDoubleAnswerRange(cta, 0);

          // clone slider to notebook
          let duplicateSlider = $(existingSlider).clone();
          $(newSlider).empty();
          if(!$(existingSlider).find(newSlider).length) $(newSlider).append(duplicateSlider);

          let selectedDistance = value['selectedDistance'];
          let firstTabLeftValue = value['firstTabLeftValue'];
          let rangeArrowElement = $($question).find(".range-selected");
          $(rangeArrowElement).css('width', selectedDistance);
          $(rangeArrowElement).css('left', firstTabLeftValue);
        }
      }
      if ( $answers.hasClass('question__answers--open') ) {
        $answers.find('span').text( value['selectedValues'] )
        $($question).find(".submitAnswer").hide();
      }
      if ( id === '000' ) {
        // if it's last question in lst gallery
        $(".notebook__sidebar__last__input").find('span').text( value['selectedValues'] );
        $(".notebook__sidebar__last__input").find('span').addClass('blocked disabled');
        $(".notebook__sidebar__last__input").find('span').removeAttr('contenteditable');
        gsap.to($(".last-question-cta"), { duration: 0.2, delay: 0, opacity: 0, pointerEvents: "none", ease: "ease" });
        gsap.to($(".notebook__sidebar__last__share"), { duration: 1, delay: 0.5, opacity: 1, pointerEvents: "all", ease: "ease" });

        gsap.fromTo($(".notebook__sidebar__last__input img"),
        { opacity: 0, transform: "rotate(10deg)", width: 180, height: 180, right: -185, bottom: -20 },
        { duration: .5, bottom: 0, right: -170, width: 220, height: 220, transform: "rotate(0deg)", delay: 0.2, opacity: 1, ease: "ease" });

        gsap.fromTo($(".mobile-stamp"),
        { opacity: 0, transform: "rotate(0deg)", width: 150, height: 150, left: -160, bottom: -10 },
        { duration: 1, bottom: 20, left: -130, width: 178, height: 178, transform: "rotate(-40deg)", delay: 0.2, opacity: 1, ease: "ease" });
      }

      if($questionType === 'multiple'){
        $notes.length && $notes.removeClass('notes--incomplete').addClass('answer--'+$questionType);
        if($question.find('.choice-box--row').length > 0){
          $notes.find('.notes__response__answer span').addClass('uppercase');
          $notes.length && $notes.find('.notes__response__correct span').addClass('uppercase');
          $notes.length && $notes.find('.notes__response__answer span').text( $actualText )
          $notes.length && $notes.find('.notes__response__correct span p').text( $correctText )
        }
        else if($question.find('.choice-box--column').length > 0){
          $notes.length && $notes.removeClass('notes--incomplete').addClass('answer--'+$questionType+'-column');
          $notes.length && $notes.find('.notes__response__answer span').text( $actualText )
          $notes.length && $notes.find('.notes__response__correct span p').text( $correctText )
        }
        if( $actualText === $correctText ){
          $notes.find('.notes__response__answer').hide();
          $notes.find('.notes__response__correct label').text("Answer");
        }
      }
      else if($questionType === 'open'){
        $notes.length && $notes.removeClass('notes--incomplete').addClass('answer--'+$questionType);
        $notes.length && $notes.find('.notes__response__answer span').text( value['selectedValues'] )
        $notes.length && $notes.find('.notes__response__correct span p').text( value['selectedValues'] )
        $($question).find("span").attr("contenteditable", false);
        $($question).find("span").addClass("disabled");
      }
      else if($questionType === 'range'){
        if(value['submitted'] === 'true') {
          $notes.length && $notes.removeClass('notes--incomplete').addClass('answer--'+$questionType);
          $notes.length && $notes.find('.notes__response__correct span').html( value['responseText'] )
        }
      }
      else if($questionType === 'last'){
        $notes.length && $notes.removeClass('notes--incomplete').addClass('answer--'+$questionType);
        $notes.length && $notes.find('.notebook__sidebar__last__input span').html( value['responseText'] )
      }
    }
    this.checkNotebookAnswers();
  },
  toggleNotebook(event) {
    event.preventDefault();
    this.$notebook.toggleClass('is-open');
    this.$tab.toggleClass('is-open');
    this.$body.toggleClass('notebook-open');

    if (this.$notebook.hasClass('is-open')) this.$tab.attr('aria-pressed', 'true');
    else this.$tab.removeAttr('aria-pressed');

    if(this.$notebook.hasClass('js-notebook-mobile')){
      if (this.$notebook.hasClass('is-open')) {
        gsap.fromTo($(".notebook__sidebar__full"), {y: "-100vh"}, { display: "block", y: "0", duration: .5 })
      } else {
        gsap.fromTo($(".notebook__sidebar__full"), {y: "0"}, { y: "-100vh", duration: 0 });
        gsap.to($(".notebook__sidebar__full"), { display: "none", duration: 0, delay: 1 });
      }
    }
  },
  checkAnswers(){
    $(".question__check-cta").on('click', function(){
      $(this).removeClass("active");
      let parentForm = $(this).closest('form');
      let correctAnswer = $(parentForm).find('[label-correct=1]');
      $(correctAnswer).addClass("correct");
      $(parentForm).find("label.preselected").removeClass("inactive").addClass("wrong-answer");
      $(correctAnswer).find("span").fadeIn();
    });
  },
  appendDoubleAnswerRange($this, correctAnswersDistance){
    let parentForm = $($this).closest('form');
    let parentFormDuplicate = $($this).closest('form').clone();
    let parentDiv = $($this).closest(".question__answers--range")
    $(parentDiv).append(parentFormDuplicate);
    $(parentFormDuplicate).addClass('answered-range');
    $(parentDiv).find('.question__submit-cta').remove();
    if($(parentForm).find(".question__range").attr("slider-type") != 'singleslider'){
      $(parentFormDuplicate).find(".connect-line").css("width", correctAnswersDistance);
    }
  },
  calcDistance(elementOne, elementTwo){
  	let distance = -1;
  	const x1 = elementOne.offset().top;
  	const y1 = elementOne.offset().left;
  	const x2 = elementTwo.offset().top;
  	const y2 = elementTwo.offset().left;
  	const xDistance = x1 - x2;
  	const yDistance = y1 - y2;
  	distance = Math.sqrt(
  		(xDistance * xDistance) + (yDistance * yDistance)
  	);
  	return distance;
  },
  initPopup(){
    const $popup = $('.js-popup').magnificPopup({
      type: 'inline',
      midClick: true,
      mainClass: 'popup--animate',
      closeMarkup: '<button class="mfp-close roundlink"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 17.1932C17.5961 16.0321 16.2397 14.8253 14.9062 13.5938C13.4495 12.2585 12.0281 10.8898 10.6259 9.5C12.0281 8.11018 13.4495 6.74148 14.9062 5.4062C16.2397 4.17648 17.5961 2.96787 19 1.80676V0H17.1932C16.0321 1.40389 14.8253 2.76028 13.5938 4.0938C12.2585 5.55046 10.8898 6.97194 9.5 8.37407C8.11018 6.97194 6.74148 5.55046 5.4062 4.0938C4.17648 2.76028 2.96787 1.40389 1.80676 0H0V1.80676C1.40389 2.96787 2.76028 4.17472 4.0938 5.4062C5.55046 6.74148 6.97194 8.11018 8.37407 9.5C6.97194 10.8898 5.55046 12.2585 4.0938 13.5938C2.76028 14.8235 1.40389 16.0321 0 17.1932V19H1.80676C2.96787 17.5961 4.17472 16.2397 5.4062 14.9062C6.74148 13.4495 8.11018 12.0281 9.5 10.6259C10.8898 12.0281 12.2585 13.4495 13.5938 14.9062C14.8235 16.2397 16.0321 17.5961 17.1932 19H19V17.1932Z" fill="black"/></svg></button>',
    });

    $(document).on('gform_confirmation_loaded', function(event, formId){
      // Fixes popup position for confirmation message on mobile
      $popup.magnificPopup('close')
      $popup.magnificPopup('open')
    });
  },
  copyUrlToClipboard(){
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(".copy-url").attr("copy-url")).select();
    document.execCommand("copy");
    $temp.remove();
    gsap.to($(".link-copied"), { duration: 0.5, bottom: "30px", ease: "ease" });
    gsap.to($(".link-copied"), { duration: 1, delay: 3, bottom: "-150px", ease: "ease" });
  },
  checkNotebookAnswers(){
    var gallery = $(".notebook__sidebar__full-gallery");
    $(gallery).each(function( index, elem ) {
      if($(elem).find(".notes--incomplete").length != 0) {
        $(elem).find(".is-open img").hide();
        $(elem).find(".notebook__sidebar__full-gallery__header img").hide();
      }
      else {
        var galleryID = $(elem).attr('data-gallery-id');
        $(".notebook__sidebar__card[data-gallery-id="+galleryID+"]").addClass('is-completed');
        $(elem).find(".is-open img").show();
        $(elem).find(".notebook__sidebar__full-gallery__header img").show();
      }
    });
  },
  
  // mobileNavigation(event, direction){
  //   // mobile navigation will switch between pages
  //   let pathname = window.location.pathname,
  //       origin   = window.location.origin,
  //       num = parseInt(pathname.replace(/[^0-9]/g,'')),
  //       textBase = pathname.replace(/\d+/g, ''),
  //       nextIndex = num + 1,
  //       prevIndex = num - 1;

  //   textBase = textBase.replaceAll("/", "")

  //   if(textBase === "" && $("body").hasClass("home")){
  //     nextIndex = 2;
  //     textBase = "gallery-";
  //   }

  //   let nextPage = origin + "/" + textBase + nextIndex,
  //       prevPage = origin + "/" + textBase + prevIndex;

  //   if(direction === 'next') window.open(nextPage, "_self")
  //   else window.open(prevPage, "_self")
  // },

  checkDeviceType(event, type){
    // when switched to mobile phone, another page will open (different template and layout)
    // called only on RESIZE, not on load
    let pathname = window.location.pathname,
        origin   = window.location.origin;

    let cookieBoolean = (document.cookie.match(/^(?:.*;)?\s*mobileDevice\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1];
    if($(window).width() <= 768 && cookieBoolean === 'false') {
      if(cookieBoolean === 'false') document.cookie = "mobileDevice=true";
      if(!$(".notebook").hasClass('js-notebook-mobile')) $(".notebook").addClass("js-notebook-mobile");
      gsap.to(".initial-screen", { duration: 0, display: "none", ease: "ease" });
      gsap.to("#content", { duration: 0, display: "none", ease: "ease" });
      window.open(origin, "_self");
    }
    else if($(window).width() > 768 && cookieBoolean === 'true') {
      if(cookieBoolean === 'true') document.cookie = "mobileDevice=false";
      if($(".notebook").hasClass('js-notebook-mobile')) $(".notebook").removeClass("js-notebook-mobile");
        gsap.to(".initial-screen", { duration: 0, display: "none", ease: "ease" });
        gsap.to("#content", { duration: 0, display: "none", ease: "ease" });
        window.open(origin, "_self");
      }
  },
  createEmailContent(){
    let emailHeader, emailFooter;
    let emailText = '', inputList = '';

    // email content
    for (const [id, value] of Object.entries(this.state)) {
      let listElement, questionText = "-", correctAnswer = "-", userAnswer = "-", rangeResponse = "-";
      if(id != 'expiry' ){
        if(value['questionText'] != "") questionText = value['questionText'];
        if(value['responseText'] != "") rangeResponse = value['responseText'];
        if(value['correctValues'] != "") {
          if(value['questionType'] === 'range'){
            if(value['correctValues'][1]) correctAnswer = "Between " + value['correctValues'][0] + " - " + value['correctValues'][1];
            else correctAnswer = value['correctValues'][0];
          }
          else correctAnswer = value['correctValues'];
        }

        if(value['selectedValues'] != "") {
          if(value['questionType'] === 'range'){
            if(value['selectedValues'][1]) userAnswer = "Between " + value['selectedValues'][0] + " - " + value['selectedValues'][1];
            else userAnswer = value['selectedValues'][0];
          }
          else userAnswer = value['selectedValues'];
        }

        listElement = `<div style="background: #fff; border-bottom: 1px solid #d0d0d0;padding: 10px 0;"><h6 style="font-size: 16px; font-weight: 500; margin: 0 0 10px; color: #80bd2f;line-height: 20px;">Q: ${questionText}</h6><p style="margin: 5px 0; color: #000;"><span style="font-weight: bold;text-transform: uppercase;font-size: 12px;">Your answer:</span> ${userAnswer}</p><p style="margin: 5px 0; color: #000;"><span style="font-weight: bold;text-transform: uppercase;font-size: 12px;">Correct answer:</span> ${correctAnswer}</p><div style="margin: 5px 0; color: #000;"><span style="font-weight: bold;text-transform: uppercase;font-size: 12px;">Additional info:</span> ${rangeResponse}</div></div>`;

        inputList = inputList + listElement;
      }
    }

    // email header
    emailHeader = '<body class="" style="background-color: #2f2f2f; font-family: sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 0; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;"><table border="0" cellpadding="0" cellspacing="0" class="body" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; background-color: #2f2f2f;"><tbody><tr><td class="container" style="font-family: sans-serif; font-size: 14px; vertical-align: top; display: block; Margin: 0 auto; max-width: 580px; padding: 10px; width: 580px;"><div class="content" style="box-sizing: border-box; display: block; Margin: 0 auto; max-width: 580px; padding: 10px;"><table class="main" style="border-collapse: separate;width: 100%;background: #ffffff;border-radius: 3px;border: 0;border-spacing: 0;"><tbody><tr><td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 40px; background: #000; "><table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;"><tbody><tr><td style="font-family: sans-serif; font-size: 14px; vertical-align: top;"> <img style="width: 80px; margin: 0 auto 20px; display: block;" src="https://isoureconomyfair.org/wp-content/themes/_towallstreet/img/logoEmail.png" /><h2 style=" color: #e7f9d1; text-align: center; margin: 0; font-size: 28px;">To what extent was our economy designed to be fair?</h2></td></tr></tbody></table></td></tr><tr><td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 40px;"><table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;"><tbody><tr><td style="font-family: sans-serif; font-size: 14px; vertical-align: top;"><p style="font-family: sans-serif; color: #000; font-size: 14px; font-weight: normal; margin: 0; Margin-bottom: 15px;">Hi there,</p><p style="font-family: sans-serif; color: #000; font-size: 14px; font-weight: normal; margin: 0; Margin-bottom: 15px;">Thank you for taking a journey with us through pivotal moments in the creation of our modern-day economy. You can review your notes here, or in your browser for the next 24 hours. We hope you picked up some new information and will encourage friends and family to experience the site too. <br> To learn about how Take on Wall Street is working to build an economy for all of us, not just the big Wall Street banks, <a href="https://actionnetwork.org/forms/stay-up-to-date-and-join-the-fight-to-take-on-wall-street/">stay up to date and join the fight.</a></p><h3 style="font-family: sans-serif; font-size: 20px; color: #000; font-weight: normal; margin-top: 40px; text-align: center;"><b>Here are your results:</b></h3><table border="0" cellpadding="0" cellspacing="0" class="btn btn-primary" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; box-sizing: border-box;"><tbody><tr>';


    // email footer
    emailFooter = '</tr></tbody></table><p style="font-family: sans-serif; font-size: 9px; font-weight: bold; margin: 0; padding-top: 25px; color: #000; line-height: 16px; border-top: 1px solid #e2e2e2;">TAKE ON WALL STREET DOES NOT COLLECT ANY PERSONAL INFORMATION FROM PEOPLE WHO USED OUR GALLERIES, AND ANY CONTENT USERS PROVIDE BY ANSWERING QUESTIONS WILL NOT BE ASSOCIATED WITH THEM IN ANY WAY. RESPONSES TO QUESTIONS WILL ONLY BE USED TO HELP TAKE ON WALL STREET BETTER UNDERSTAND COMMONALITIES AND DIFFERENCES BETWEEN USERS’ UNDERSTANDINGS OF WALL STREET.</p></td></tr></tbody></table></td></tr><tr><td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 40px; background: #000; "><table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;"><tbody><tr><td style="font-family: sans-serif; font-size: 14px; vertical-align: top;"><h4 style=" color: white; text-align: center; margin: 0; font-size: 20px; padding: 20px 0; ">Visit us on socials!</h4><div style="display: inline-block; text-align: center; width: 100%;"> <a href="https://www.facebook.com/TakeOnWallStreet/" style="color: #7fbd2f; margin: 0 10px; width: 30px; height: 30px;" target="_blank"> <img style="width: 30px; height: 30px;" src="https://isoureconomyfair.org/wp-content/themes/_towallstreet/img/Facebook.png" alt="Facebook link"> </a> <a href="https://www.instagram.com" style="color: #7fbd2f; margin: 0 10px; width: 30px; height: 30px;" target="_blank"> <img style="width: 30px; height: 30px;" src="https://isoureconomyfair.org/wp-content/themes/_towallstreet/img/Instagram.png" alt="Instagram link"> </a> <a href="https://twitter.com/TakeOnWallSt" style="color: #7fbd2f; margin: 0 10px; width: 30px; height: 30px;" target="_blank"> <img style="width: 30px; height: 30px;" src="https://isoureconomyfair.org/wp-content/themes/_towallstreet/img/Twitter.png" alt="Twitter link"> </a></div></td></tr></tbody></table></td></tr><tr><td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 40px; background: #000; "><table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;"><tbody><tr><td class="content-block" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 14px; color: #fff; text-align: center;"> <span class="apple-link" style="color: #fff; font-size: 14px; text-align: center; padding-bottom: 5px; display: block;">Social Activity © 2021 | Take On Wall Street | All Rights Reserved</span> Visit out our site <a href="https://takeonwallst.com" style="color: #7fbd2f; font-size: 14px; text-align: center;">Take On Wall Street</a></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table></body>';

    // create full email and push to field
    emailText = emailHeader + inputList + emailFooter;
    $(".email-content textarea").text("");
    $(".email-content textarea").text(emailText)
  },
  initialScreen(){
    let pathname = window.location.pathname,
        origin   = window.location.origin,
        num = parseInt(pathname.replace(/[^0-9]/g,''));
    if(num === 1) $(".gallery-nav--mobile #prevGalleryNav").hide();
    if(num === 14) $(".gallery-nav--mobile #nextGalleryNav").hide();

    if($("body").hasClass("home") || $("body").hasClass("first-mobile-gallery")){
      gsap.to(".initial-screen__top", { duration: 3, delay: 0, opacity: 1, ease: "expo" });
      gsap.to(".initial-screen__inner h1", { duration: 2, delay: 1, opacity: 1, ease: "expo" });
      gsap.to(".initial-screen__bottom", { duration: 1, opacity: 1, delay: 1.5, ease: "expo"});
      gsap.to(".initial-screen__bottom", { duration: 2.8, delay: 2, width: "100%", maxWidth: "100%", ease: "expo.inOut" });
      gsap.to(".initial-screen__bottom__text p", { duration: 2, delay: 3.5, opacity: 1, ease: "expo" });
      gsap.to(".initial-screen__bottom__frame a", { duration: 2, delay: 3.5, opacity: 1, ease: "expo" });
      gsap.to(".initial-screen__mobile-img", { duration: 0, overflow: "hidden", borderRadius: "50%" });
      gsap.to(".initial-screen__mobile-img", { duration: 2, delay: 1.5, opacity: 1, ease: "expo" });
      gsap.to(".initial-screen__mobile-img img", { duration: 5, delay: 1.5, width: "140%", marginLeft: "-20%", marginTop: "-30%", height: "140%", ease: "linear" });
      gsap.to(".initial-screen__bottom__img .ellipse-img", { duration: 10, delay: 1.5, transform: "scale(1.3)", ease: "linear" });
      gsap.to(".initial-screen__bottom__frame .ellipse-bg", { duration: 10, delay: 1.5, transform: "scale(1.3)", ease: "linear" });
      gsap.to(".initial-screen__mobile-cta", { duration: 2, delay: 1.5, opacity: 1, ease: "expo" });
      gsap.fromTo("#initialScreenNext svg", 2, { y: -15}, { y: 15, ease: "power3.inOut", yoyo: true, repeat: -1 });
      gsap.to(".initial-screen__bottom__text ellipse", { animation: "dash 2.5s linear forwards",  delay: 3.5, duration: 0});
    }

    $("#initialScreenNext").on('click', function(){
      $("body").removeClass("scrollingDisabled");
      $(".notebook__sidebar__card").eq(1).addClass("is-active");
      $(".notebook__sidebar__card").eq(1).find(".notebook__sidebar__title").slideToggle();
      gsap.to(".initial-screen", { duration: 2, delay: 0, margin: "-100vh 0 0 0", ease: "power3.inOut" });
      gsap.to(".initial-screen", { duration: 1, delay: 1, display: "none" });
      gsap.to("body", { duration: 1, delay: 0, overflow: "auto" });
      gsap.from(".notebook", { duration: 2, delay: 0, x: 290, ease: "power3.inOut" });
      gsap.from(".header", { duration: 2, delay: 1, y: -72, ease: "power3.inOut" });
      gsap.from(".title__gallery-year", { duration: 2, delay: 1, y: -72, ease: "power3.inOut" });

      gsap.fromTo(".scrollToContinue", { right: -300 }, { duration: 2, opacity: 1, delay: 1, right: 285, ease: "power3.inOut" });
      gsap.fromTo(".gallery-module:not(.gallery-module--first)", { opacity: 0 }, { delay: 2, duration: 2, opacity: 1, ease: "power3.inOut" });
      gsap.fromTo(".gallery-module--first", { opacity: 0, y: 300 }, { duration: 3, delay: .5, opacity: 1, y: 0, ease: "power3.inOut" } );

      //create 2 timelines
      var arrowEl = document.getElementById("scrollArrow");

      var arrowAnim1 = new TimelineLite();
      arrowAnim1.fromTo(".animated-arrow-bg", { left: -300 }, {  delay: 0, duration: 1.5, left: 0, ease: "expo.inOut" })
      var arrowAnim2 = new TimelineLite();
      arrowAnim2.to(".animated-arrow-bg", 1.5, {left: 300, ease: "expo.inOut"})
      var masterTimeline = new TimelineLite({onComplete:function() {
         masterTimeline.restart();
      }});
      masterTimeline.add(arrowAnim1).add(arrowAnim2)

      arrowEl.addEventListener('mouseenter', function() {
        masterTimeline.pause();
      });
      arrowEl.addEventListener('mouseleave', function() {
        masterTimeline.play();
      });

    });

    // Mobile initial screen
    $(".initial-screen__mobile-cta a").on('click', function(){
      $("body").removeClass("scrollingDisabled");
      gsap.to("body", {duration: 0, overflow: "scroll"});
      gsap.to(".initial-screen", {duration: 2, y: "-100%", ease: "power3.inOut"});
      gsap.to(".initial-screen", {duration: 0, delay: 1.5, display: "none"});
      gsap.from(".notebook", { duration: 1.4, delay: 0.5, y: -110, ease: "power3.inOut" });
      gsap.from(".gallery-fixed__header.fixed", { duration: 1.4, delay: 0, y: -110, ease: "power3.inOut" });
    });
  },
};

Mangrove.init();
